var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('base-material-card',{attrs:{"title":"Create new Article Publisher task"}},[_c(_setup.CreateNewArticlePublisherTaskForm,{on:{"created":_setup.onTaskCreated}})],1),_c('base-material-card',{attrs:{"title":"Article Publisher tasks"}},[_c(_setup.ArticlePublisherTaskDataTable,{ref:"taskTableRef"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }